import basicScroll from 'basicscroll'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const { $ } = window

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {
		scrollReveals()
		parallax()
	},
	finalize() {},
}

function scrollReveals() {
	let ct_tl = gsap.timeline({
		scrollTrigger: {
			trigger: '.main-content-wrap',
			start: 'top center+=300', // when the top of the trigger hits the center of the viewport
			// markers: true,
		},
	})
	let $contactSidebar = $('.contact-sidebar')
	if ($contactSidebar.length) {
		ct_tl.fromTo(
			$contactSidebar,
			{
				opacity: 0,
				x: -40,
			},
			{
				delay: 0,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
	}
	let $contactFormWrap = $('.contact-form-wrap')
	if ($contactFormWrap.length) {
		ct_tl.fromTo(
			$contactFormWrap,
			{
				opacity: 0,
				x: 40,
			},
			{
				delay: 0,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
	}
}

function parallax() {
	let scrollAnimations = []

	scrollAnimations.push(
		basicScroll.create({
			elem: $('.main-content-wrap .compass-svg')[0],
			from: 'top-bottom',
			to: 'bottom-top',
			direct: true,
			props: {
				'--cr':
					innerWidth > 600
						? {
								from: '-20deg',
								to: '10deg',
						  }
						: {
								from: '-20deg',
								to: '10deg',
						  },
			},
		})
	)

	if (scrollAnimations.length) {
		scrollAnimations.forEach((instance) => instance.start())
	}
}
